/**
 * Notification Types for Universal Notification System
 * Type definitions for notification data structures
 */

/**
 * Notification priority levels
 */
export const NOTIFICATION_PRIORITIES = ['low', 'medium', 'high', 'urgent'];

/**
 * Notification categories
 */
export const NOTIFICATION_CATEGORIES = ['appointments', 'pa', 'claims', 'encounters', 'system'];

/**
 * Notification event types
 */
export const NOTIFICATION_EVENT_TYPES = [
  // Appointments
  'appointment.booked',
  'appointment.confirmed',
  'appointment.cancelled',
  'appointment.converted',
  'appointment.expired',
  // PA (Pre-Authorization)
  'pa.created',
  'pa.approved',
  'pa.rejected',
  'pa.query_responded',
  'pa.flagged',
  // Encounters/Check-ins
  'encounter.created',
  'encounter.updated',
  // Claims
  'claim.paid',
  'claim.approved',
  'claim.rejected',
  // Organizations / HR
  'staff_upload_updated',
  // System
  'system.alert',
  'system.maintenance',
  'system.broadcast',
  'system.app_update',
  'system.emergency',
];

/**
 * Local storage keys
 */
export const STORAGE_KEYS = {
  NOTIFICATIONS: 'admin_notifications',
  UNREAD_COUNT: 'admin_unread_count',
  LAST_SYNC: 'admin_last_sync',
};

/**
 * Maximum notifications to store in localStorage
 */
export const MAX_NOTIFICATIONS = 100;

/**
 * Default pagination size
 */
export const DEFAULT_PAGE_SIZE = 50;

/**
 * Default filter options
 */
export const DEFAULT_FILTERS = {
  category: 'all',
  read: 'all',
};


